import * as React from 'react';
import {get} from 'lodash';

import fetch from '../fetch';
import {DataSource} from '../../Definitions';

const CACHE: {
	[key: string]: any;
} = {};

type WithDataSourceProps = {
	uri: string;
	onRequest?: boolean;
	data?: {
		[key: string]: any;
	};
}
export default ({uri, onRequest, data = {}}: WithDataSourceProps): DataSource => {
	const [isFetchable, setIsFetchable] = React.useState(!onRequest);
	const [requestData, setRequestData] = React.useState(data);
	const [dataSource, updateDataSource] = React.useState({
		data: null,
		hasBeenRequested: false,
		isFailed: false,
		isLoading: false,
	});

	const update = (update = {}) =>
		updateDataSource((prevState) => ({
			...prevState,
			...update
		}));

	const fail = () => update({
		isFailed: true,
		isLoading: false
	});

	React.useEffect(() => {
		if (!isFetchable) {
			return;
		}

		(async () => {
			update({
				hasBeenRequested: true,
				isLoading: true
			});

			const fullUri = [uri, Object.entries(requestData)
				.map(([key, value]) => `${key}=${value}`)
				.join('&')
			]
				.filter(i => i)
				.join('?');

			const cacheEntry = get(CACHE, fullUri);

			switch (cacheEntry) {
			case undefined:
				CACHE[fullUri] = null;

				const response = await fetch(fullUri);

				if (response.status === 200) {
					try {
						const data = await response.json();
						CACHE[fullUri] = data;

						update({
							data,
							isLoading: false,
						});
					} catch(e) {
						fail();
					}
				} else {
					fail();
				}
				break;
			case null:
				return;
			default:
				update({
					data: cacheEntry,
					isLoading: false,
				});
			}
		})();
	}, [uri, updateDataSource, requestData]);

	return {
		...dataSource,
		refresh: (data: any) => {
			setIsFetchable(true);
			update({
				data: null,
			});
			setRequestData(data);
		}
	};
}
